import React from 'react'
import { useAuth } from '../../Context/ContextProvider';
import Description from '../Metiral/Description';
import { Link, useNavigate } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import dummyImage from '../../Assete/dummy image.png';
function ListingSection({ latestStory, pagination }) {
  // Sample data (kept from original implementation)


  const { base_url, objectToQueryString } = useAuth();
  const navigate = useNavigate()
  const dateFormate = (date) => {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Returns a human‑readable "time ago" string
  const timeAgo = (time) => {
    if (!time) return '';
    const now = new Date();
    const diffSec = Math.floor((now - new Date(time)) / 1000);
    if (diffSec < 60) return 'just now';
    const diffMin = Math.floor(diffSec / 60);
    if (diffMin < 60) return `${diffMin} minute${diffMin !== 1 ? 's' : ''} ago`;
    const diffHr = Math.floor(diffMin / 60);
    if (diffHr < 24) return `${diffHr} hour${diffHr !== 1 ? 's' : ''} ago`;
    const diffDay = Math.floor(diffHr / 24);
    if (diffDay < 30) return `${diffDay} day${diffDay !== 1 ? 's' : ''} ago`;
    const diffMonth = Math.floor(diffDay / 30);
    if (diffMonth < 12) return `${diffMonth} month${diffMonth !== 1 ? 's' : ''} ago`;
    const diffYear = Math.floor(diffMonth / 12);
    return `${diffYear} year${diffYear !== 1 ? 's' : ''} ago`;
  };

  // Use the passed in latestStory if provided, otherwise fall back to the static data above
  // const stories = latestStory?.length ? latestStory : data;
  const gotToNextPage = (data) => {
    const queryString = objectToQueryString(data);
    navigate(`/media-room?${queryString}`, { replace: true });
    console.log(data)
  }
  return (
    <div className="media_room py-5 px-md-4 px-0">
      <div className="container">
        <h4 className='text-center'>Media Room</h4>
        <p className="pera text-center">Professors' Stories: Inspiration from the Forefront of biological sciences</p>
        <div className="grid">
          {latestStory?.map((item) => (
            <Link to={`/media-detail/${item?._id}`} key={item.name}>
              <div className="story_card" key={item.name}>
                <div className="img">
                  <img src={item?.userPicture ? item?.userPicture : dummyImage} alt="..." />
                </div>
                <div className="p-2">
                  <div className="d-flex justify-content-between">
                    <span>{dateFormate(item?.createdAt)}</span>
                    <span>{timeAgo(item?.createdAt)}</span>
                  </div>
                  <h6 className="mt-2">{item?.name}</h6>
                  <Description content={item?.storyContent} />
                  {/* <div dangerouslySetInnerHTML={{ __html: item?.storyContent }} /> */}
                </div>
              </div>
            </Link>

          ))}
        </div>
        {pagination?.total_pages > 1 ? <div className="row">
          <div className="col-lg-12">
            <div className="pagination-area d-flex justify-content-between align-items-center">
              <nav>
                <ul className="page-numbers d-inline-flex">
                  {[...Array(pagination?.total_pages)].map((item, index) => {
                    return (
                      <li onClick={() => gotToNextPage({ current_page: index + 1, per_page: pagination?.per_page })}>
                        <span className={`page-number ${index + 1 === pagination?.current_page ? 'active' : ''}`} >{index + 1}</span>
                      </li>
                    )
                  })}

                  <li>
                    <span className="page-number next" onClick={() => gotToNextPage({ action: 'next' })}>
                      <FaArrowRight />

                    </span>
                  </li>
                </ul>
              </nav>
              <div className='mt-2'>
                <label className='me-2'>Results Per Page: </label>
                <select value={pagination?.per_page} onChange={(e) => {
                  gotToNextPage({ per_page: e.target.value, current_page: pagination?.current_page })
                }}>
                  <option value="12">12</option>
                  <option value="16">16</option>
                  <option value="20">20</option>
                  <option value="24">24</option>
                  <option value="50">50</option>
                </select>
              </div>
            </div>
          </div>
        </div> : null}
      </div>
    </div>
  )
}

export default ListingSection